// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/power_mtm_model.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's power_mtm_model.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MTMIssue, MTMPositionResult } from "./mtm_model_pb";
import { file_devtool_emodel_v1_mtm_model } from "./mtm_model_pb";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/power_mtm_model.proto.
 */
export const file_devtool_emodel_v1_power_mtm_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_devtool_emodel_v1_mtm_model, file_google_type_date]);

/**
 * @generated from message devtool.emodel.v1.PowerMTMPosition
 */
export type PowerMTMPosition = Message<"devtool.emodel.v1.PowerMTMPosition"> & {
  /**
   * @generated from field: string position_id = 1;
   */
  positionId: string;

  /**
   * 市場エリア（ticker/curve 解決 + カレンダーに使用）
   *
   * @generated from field: devtool.emodel.v1.PowerArea area = 2;
   */
  area: PowerArea;

  /**
   * 受渡先エリア（optional）。calendar_source=AREA かつ delivery_type=JEPX の
   * クロスエリア受渡（delivery_area が area と異なる）の場合のみ、Peak / Off-peak の
   * delivery_points 生成で area と delivery_area 両方のカレンダーを参照し、
   * どちらか休日なら除外する。BG / EEX では参照しない。
   * ticker/curve 解決には使用しない。
   *
   * @generated from field: devtool.emodel.v1.PowerArea delivery_area = 12;
   */
  deliveryArea: PowerArea;

  /**
   * @generated from field: devtool.emodel.v1.PowerHourType hour_type = 3;
   */
  hourType: PowerHourType;

  /**
   * @generated from field: devtool.emodel.v1.PowerDeliveryType delivery_type = 4;
   */
  deliveryType: PowerDeliveryType;

  /**
   * @generated from field: devtool.emodel.v1.PowerDeliveryPeriodType delivery_period_type = 5;
   */
  deliveryPeriodType: PowerDeliveryPeriodType;

  /**
   * @generated from field: google.type.Date delivery_start = 6;
   */
  deliveryStart?: Date;

  /**
   * 受渡終了日（inclusive）
   *
   * @generated from field: google.type.Date delivery_end = 7;
   */
  deliveryEnd?: Date;

  /**
   * 約定数量 kW（正=買い, 負=売り）。hour_type に応じて kWh に変換される。
   *
   * @generated from field: double volume_kw = 8;
   */
  volumeKw: number;

  /**
   * 約定単価（円/kWh）
   *
   * @generated from field: double contract_price = 9;
   */
  contractPrice: number;

  /**
   * Floating index ticker
   *
   * @generated from field: optional string floating_ticker = 10;
   */
  floatingTicker?: string;

  /**
   * 決済済み日付（この日以前の受渡日は決済済みとして扱う）
   *
   * @generated from field: optional google.type.Date settled_until = 11;
   */
  settledUntil?: Date;

  /**
   * Peak / Off-peak の delivery_points 生成に使うカレンダー。caller が deal/leg の
   * 文脈 (EEX 現先取引か否か等) を踏まえて決めてセットする。UNSPECIFIED
   * は AREA と同義 (後方互換)。
   *
   * @generated from field: devtool.emodel.v1.PowerCalendarSource calendar_source = 13;
   */
  calendarSource: PowerCalendarSource;
};

/**
 * Describes the message devtool.emodel.v1.PowerMTMPosition.
 * Use `create(PowerMTMPositionSchema)` to create a new message.
 */
export const PowerMTMPositionSchema: GenMessage<PowerMTMPosition> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_power_mtm_model, 0);

/**
 * @generated from message devtool.emodel.v1.CalculatePowerMTMRequest
 */
export type CalculatePowerMTMRequest = Message<"devtool.emodel.v1.CalculatePowerMTMRequest"> & {
  /**
   * @generated from field: google.type.Date reference_date = 1;
   */
  referenceDate?: Date;

  /**
   * @generated from field: devtool.emodel.v1.PowerCurveSource curve_source = 2;
   */
  curveSource: PowerCurveSource;

  /**
   * @generated from field: repeated devtool.emodel.v1.PowerMTMPosition positions = 3;
   */
  positions: PowerMTMPosition[];

  /**
   * When false (default), per-position date_results and settlement_cashflows
   * are omitted from the response; only totals are returned. Set to true for
   * debugging / devtool use to receive the full daily breakdown.
   *
   * @generated from field: bool include_details = 4;
   */
  includeDetails: boolean;
};

/**
 * Describes the message devtool.emodel.v1.CalculatePowerMTMRequest.
 * Use `create(CalculatePowerMTMRequestSchema)` to create a new message.
 */
export const CalculatePowerMTMRequestSchema: GenMessage<CalculatePowerMTMRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_power_mtm_model, 1);

/**
 * @generated from message devtool.emodel.v1.CalculatePowerMTMResponse
 */
export type CalculatePowerMTMResponse = Message<"devtool.emodel.v1.CalculatePowerMTMResponse"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.PowerMTMTickerGroupResult ticker_group_results = 1;
   */
  tickerGroupResults: PowerMTMTickerGroupResult[];

  /**
   * @generated from field: int32 runtime_ms = 2;
   */
  runtimeMs: number;

  /**
   * @generated from field: repeated devtool.emodel.v1.MTMIssue issues = 3;
   */
  issues: MTMIssue[];

  /**
   * Sum of every PowerMTMTickerGroupResult.mtm. Callers that only need
   * the response-level total can read this directly without walking
   * ticker_group_results / position_results.
   * This is the sum of the returned position results only. A position that
   * has an issue with its position_id (e.g. MTM_ISSUE_REASON_CURVE_GAP) has
   * no result and is not included, so when such an issue is present this is
   * not the total MTM of all requested positions. Issues without a
   * position_id do not remove any result.
   *
   * @generated from field: double total_mtm = 4;
   */
  totalMtm: number;
};

/**
 * Describes the message devtool.emodel.v1.CalculatePowerMTMResponse.
 * Use `create(CalculatePowerMTMResponseSchema)` to create a new message.
 */
export const CalculatePowerMTMResponseSchema: GenMessage<CalculatePowerMTMResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_power_mtm_model, 2);

/**
 * @generated from message devtool.emodel.v1.PowerMTMTickerGroupResult
 */
export type PowerMTMTickerGroupResult = Message<"devtool.emodel.v1.PowerMTMTickerGroupResult"> & {
  /**
   * デバッグ用に解決された ticker を返す
   *
   * @generated from field: string resolved_ticker = 1;
   */
  resolvedTicker: string;

  /**
   * @generated from field: repeated devtool.emodel.v1.MTMPositionResult position_results = 2;
   */
  positionResults: MTMPositionResult[];

  /**
   * Sum of mtm_total across position_results — the ticker group's
   * contribution to total_mtm. Positions with an issue (with their
   * position_id) have no result and are not included.
   *
   * @generated from field: double mtm = 3;
   */
  mtm: number;
};

/**
 * Describes the message devtool.emodel.v1.PowerMTMTickerGroupResult.
 * Use `create(PowerMTMTickerGroupResultSchema)` to create a new message.
 */
export const PowerMTMTickerGroupResultSchema: GenMessage<PowerMTMTickerGroupResult> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_power_mtm_model, 3);

/**
 * @generated from enum devtool.emodel.v1.PowerArea
 */
export enum PowerArea {
  /**
   * @generated from enum value: POWER_AREA_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: POWER_AREA_HOKKAIDO = 1;
   */
  HOKKAIDO = 1,

  /**
   * @generated from enum value: POWER_AREA_TOHOKU = 2;
   */
  TOHOKU = 2,

  /**
   * @generated from enum value: POWER_AREA_TOKYO = 3;
   */
  TOKYO = 3,

  /**
   * @generated from enum value: POWER_AREA_CHUBU = 4;
   */
  CHUBU = 4,

  /**
   * @generated from enum value: POWER_AREA_HOKURIKU = 5;
   */
  HOKURIKU = 5,

  /**
   * @generated from enum value: POWER_AREA_KANSAI = 6;
   */
  KANSAI = 6,

  /**
   * @generated from enum value: POWER_AREA_CHUGOKU = 7;
   */
  CHUGOKU = 7,

  /**
   * @generated from enum value: POWER_AREA_SHIKOKU = 8;
   */
  SHIKOKU = 8,

  /**
   * @generated from enum value: POWER_AREA_KYUSHU = 9;
   */
  KYUSHU = 9,
}

/**
 * Describes the enum devtool.emodel.v1.PowerArea.
 */
export const PowerAreaSchema: GenEnum<PowerArea> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_power_mtm_model, 0);

/**
 * @generated from enum devtool.emodel.v1.PowerHourType
 */
export enum PowerHourType {
  /**
   * @generated from enum value: POWER_HOUR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 24h (全48コマ)
   *
   * @generated from enum value: POWER_HOUR_TYPE_BASE = 1;
   */
  BASE = 1,

  /**
   * 8:00-20:00 JST (コマ17-40, 12h)。calendar_source で解決したカレンダーの休日は受渡なし
   *
   * @generated from enum value: POWER_HOUR_TYPE_PEAK = 2;
   */
  PEAK = 2,

  /**
   * 8:00-20:00 JST 以外 (コマ1-16, 41-48, 12h)。受渡日は PEAK と同じ (休日は受渡なし)
   *
   * @generated from enum value: POWER_HOUR_TYPE_OFF_PEAK = 3;
   */
  OFF_PEAK = 3,
}

/**
 * Describes the enum devtool.emodel.v1.PowerHourType.
 */
export const PowerHourTypeSchema: GenEnum<PowerHourType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_power_mtm_model, 1);

/**
 * @generated from enum devtool.emodel.v1.PowerCurveSource
 */
export enum PowerCurveSource {
  /**
   * @generated from enum value: POWER_CURVE_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: POWER_CURVE_SOURCE_ENECHAIN = 1;
   */
  ENECHAIN = 1,

  /**
   * @generated from enum value: POWER_CURVE_SOURCE_EEX = 2;
   */
  EEX = 2,
}

/**
 * Describes the enum devtool.emodel.v1.PowerCurveSource.
 */
export const PowerCurveSourceSchema: GenEnum<PowerCurveSource> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_power_mtm_model, 2);

/**
 * @generated from enum devtool.emodel.v1.PowerDeliveryType
 */
export enum PowerDeliveryType {
  /**
   * @generated from enum value: POWER_DELIVERY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 物理取引（physically_settled）
   *
   * @generated from enum value: POWER_DELIVERY_TYPE_BG = 1;
   */
  BG = 1,

  /**
   * スポット市場（financial）
   *
   * @generated from enum value: POWER_DELIVERY_TYPE_JEPX = 2;
   */
  JEPX = 2,

  /**
   * 先物（financial）
   *
   * @generated from enum value: POWER_DELIVERY_TYPE_EEX = 3;
   */
  EEX = 3,
}

/**
 * Describes the enum devtool.emodel.v1.PowerDeliveryType.
 */
export const PowerDeliveryTypeSchema: GenEnum<PowerDeliveryType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_power_mtm_model, 3);

/**
 * @generated from enum devtool.emodel.v1.PowerDeliveryPeriodType
 */
export enum PowerDeliveryPeriodType {
  /**
   * @generated from enum value: POWER_DELIVERY_PERIOD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: POWER_DELIVERY_PERIOD_TYPE_MONTH = 1;
   */
  MONTH = 1,

  /**
   * @generated from enum value: POWER_DELIVERY_PERIOD_TYPE_QUARTER = 2;
   */
  QUARTER = 2,

  /**
   * @generated from enum value: POWER_DELIVERY_PERIOD_TYPE_SEASON = 3;
   */
  SEASON = 3,

  /**
   * @generated from enum value: POWER_DELIVERY_PERIOD_TYPE_FISCAL_YEAR = 4;
   */
  FISCAL_YEAR = 4,
}

/**
 * Describes the enum devtool.emodel.v1.PowerDeliveryPeriodType.
 */
export const PowerDeliveryPeriodTypeSchema: GenEnum<PowerDeliveryPeriodType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_power_mtm_model, 4);

/**
 * Peak / Off-peak の delivery_points 生成時に参照するカレンダー種別。
 * caller が deal/leg の文脈を踏まえて明示的にセットする。
 *   AREA: 送配電エリア休日カレンダー (area / delivery_area を参照)
 *   EEX:  EEX 清算カレンダー (現先取引、あるいは EEX 先物 tx の場合)
 *
 * @generated from enum devtool.emodel.v1.PowerCalendarSource
 */
export enum PowerCalendarSource {
  /**
   * @generated from enum value: POWER_CALENDAR_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: POWER_CALENDAR_SOURCE_AREA = 1;
   */
  AREA = 1,

  /**
   * @generated from enum value: POWER_CALENDAR_SOURCE_EEX = 2;
   */
  EEX = 2,
}

/**
 * Describes the enum devtool.emodel.v1.PowerCalendarSource.
 */
export const PowerCalendarSourceSchema: GenEnum<PowerCalendarSource> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_power_mtm_model, 5);

